import View from '../../../../../../View'
import {HIDE_ANIMATION_CLASSES, PANEL_TYPES, SHOW_ANIMATION_CLASSES} from '../../../../../../panels/constants'
import LoadingContainer from '../../../../../../util/LoadingContainer'
import PanelContainer from '../../../../../../components/PanelContainer'
import {connect} from '../../../../../../redux/utils'
import {bindActionCreators} from 'redux'
import HolidayListPanelContent from './HolidayListPanelContent'
import {isLoadingHolidayList, isShownHolidayList} from '../selectors'
import {closePanel} from '../actions'

class HolidayListPanel extends View {
    constructor({
        closePanel
    }) {
        super()

        this.actions = {
            closePanel
        }

        this.state = {
            isShown: false,
            loading: false
        }

        this.onStatePropertyChanged('loading', (loading) => {
            this.loadingContainer.setState({loading})
        })
        this.onStatePropertyChanged('isShown', (isShown) => {
            this.panelContainerWrapper.setState({isShown})
        })
    }

    afterRender() {
        this.loadingContainer = new LoadingContainer({
            contentComponent: new HolidayListPanelContent(),
            containerClass: "loading_holidayListPanel",
            contentClass: "loading_holidayListPanel_content",
            loadingMoireConfig: {
                delay: 100
            },
        })
        this.panelContainerWrapper = new PanelContainer({
            component: this.loadingContainer,
            additionalClass: 'holidayListPanel',
            showAnimationClass: SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
            hideAnimationClass: HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
            hideOnEsc: true,
            showHideButton: true,
            onHideCallback: () => this.actions.closePanel(),
            hideOnClickOutside: {
                hideOnClick: true,
                panelType: PANEL_TYPES.HOLIDAY_LIST_PANEL,
            },
            hideHandler: () => this.panelContainerWrapper.setState({isShown: false}),
            onClickCloseButton: () => this.actions.closePanel(),
        }).init(this.$containerEl)
    }
}

export default connect(
    state => ({
        isShown: isShownHolidayList(state),
        loading: isLoadingHolidayList(state),
    }),
    dispatch => ({
        closePanel: bindActionCreators(closePanel, dispatch),
    }),
)(HolidayListPanel)


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/holidayList/components/HolidayListPanel.js